import { getCurrentYear, monthNames } from "../utils/monthYear";

function MonthYearSelector({
  selectedMonth,
  selectedYear,
  setSelectedMonth,
  setSelectedYear,
}) {
  const currentYear = getCurrentYear();
  const years = [
    currentYear - 3,
    currentYear - 2,
    currentYear - 1,
    currentYear,
    currentYear + 1,
  ];

  return (
    <div className="month-year-selector" aria-label="Month and year selector">
      <select
        value={selectedMonth}
        onChange={(event) => setSelectedMonth(Number(event.target.value))}
      >
        {monthNames.map((name, index) => (
          <option key={name} value={index + 1}>
            {name}
          </option>
        ))}
      </select>

      <select
        value={selectedYear}
        onChange={(event) => setSelectedYear(Number(event.target.value))}
      >
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  );
}

export default MonthYearSelector;
